import { Link } from "react-router-dom";

export function Logo({ className = "", textClass = "", onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="logo-link"
      className={`inline-flex items-center gap-2.5 ${className}`}
    >
      <img
        src="/logo.png"
        alt="Kinect Nova AI logo"
        width={36}
        height={36}
        className="h-9 w-9 rounded-xl shadow-sm"
      />
      <span className={`font-heading text-lg font-bold tracking-tight ${textClass}`}>
        Kinect<span className="text-marigold-deep"> Nova AI</span>
      </span>
    </Link>
  );
}
